<template>
  <div class="flex flex-col items-center my-10 md:my-20">
    <Temporary v-if="showDevbuttons" />

    <div v-if="!emailSent" class="flex flex-col items-center lg:w-3/4">
      <h1 class="text-xl md:text-3xl font-bold md:text-center mb-8">
        If you would like to seek reimbursement for expenses, you are welcome to
        send in a claim
      </h1>
      <p class="text-sm md:text-base leading-loose md:text-center mb-12">
        Documentation is key, so make sure you have the correct paperwork to
        attach to your claim. For instance, if you have seen a doctor you need
        to have the receipt and the doctor’s note at hand. If something was
        stolen, you need to have a police report. To start your online claim,
        please enter your booking number and date of birth. Please note that if
        you are 18 years or older, the online claim form needs to be filled out
        by you.
      </p>
    </div>

    <div class="lg:w-3/4">
      <transition name="slide-fade" mode="out-in">
        <ConfirmUserForm
          v-if="!confirmUserCompleted"
          key="1"
          @completed="confirmUserCompleted = true"
        />
        <EmailForm
          v-if="confirmUserCompleted"
          key="2"
          :email-sent="emailSent"
          @completed="emailSent = true"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import Temporary from '@/components/Start/Temporary.vue';
import ConfirmUserForm from '@/components/Start/ConfirmUserForm/ConfirmUserForm.vue';
import EmailForm from '@/components/Start/EmailForm/EmailForm.vue';

export default {
  name: 'Start',
  components: {
    Temporary,
    ConfirmUserForm,
    EmailForm
  },
  data: () => ({
    confirmUserCompleted: false,
    emailSent: false
  }),
  computed: {
    showDevbuttons() {
      return process.env.NODE_ENV === 'development';
    }
  }
};
</script>

<style lang="scss" scoped>
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease-out;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-25px);
  opacity: 0;
}
</style>
